// extracted by mini-css-extract-plugin
module.exports = {"list":"faq_list__iMjRJ","item":"faq_item__ocOa_","question":"faq_question__XlJEw","toggle":"faq_toggle__KGmSQ","answer":"faq_answer___MrJy"};